
<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmSinister"
          :title="$lang.CarInspection.Search.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSearchButton="true"
          :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
          v-on:Clear="onClear"
          v-on:Search="onSearch">
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxInsure"> {{$lang.CarInspection.Search.Insurer}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.insurance.value"
                      :options="getAllInsurer"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtInsured"> {{$lang.CarInspection.Search.Insured}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-user"></i></span>
            <b-form-input type="text"
                          name="txtInsured"
                          :placeholder="$lang.CarInspection.Search.PlaceholderEnterInsured"
                          v-model="form.insured.value"
                          :size="form.insured.maxlength"
                          :state="form.insured.state"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure">{{$lang.CarInspection.Search.Stage}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.stage.value"
                      :options="getAllStage"/>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <label for="txtCodeSinister"> {{$lang.CarInspection.Search.SinisterCode}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtCodeSinister"
                          :placeholder="$lang.CarInspection.Search.PlaceholderEnteSinisterCode"
                          v-model="form.sinisterCode.value"
                          :size="form.sinisterCode.maxlength"
                          :state="form.sinisterCode.state"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtPlate"> {{$lang.CarInspection.Search.Plate}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtPlate"
                          :placeholder="'BRA-12J4'"
                          v-model="form.plate.value"
                          :size="form.plate.maxlength"
                          :required="form.plate.required"
                          :state="form.plate.state"
                          />
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtSinisterDateStart">{{$lang.CarInspection.Search.DateStart}}:</label>
          <div class="input-group">
            <datepicker name="txtSinisterDateStart" v-model="form.sinisterDateStart.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtSinisterDateEnd"> {{$lang.CarInspection.Search.DateEnd}}:</label>
          <div class="input-group">
            <datepicker name="txtSinisterDateEnd" v-model="form.sinisterDateEnd.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure"> {{$lang.CarInspection.Search.Expert}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.expert.value"
                      :disabled="isRegulator"
                      :options="getAllExpert"/>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <label for="cbxInsure"> {{$lang.CarInspection.Search.RegulationType}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.regulationType.value"
                      :options="getAllRegulationType"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxInsure"> {{$lang.CarInspection.Search.SchedulingType}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.schedulingType.value"
                      :options="getAllSchedulingType"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxType"><small v-show="form.ranking.required" class="text-danger">*</small> {{ $lang.CarInspection.Search.AutoType }}:</label>
          <div class="input-group">
            <span class="input-group-addon input-group-addon-icondropdown"><i class="fa fa-truck"></i></span>
            <b-form-select v-model="form.ranking.value"
                          :options="form.ranking.options"
                          :state="form.ranking.state"
                          class="mb-3"
                          name="cbxType">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="1">{{$lang.AutoType.Ranking.Light}}</option>
                <option :value="2">{{$lang.AutoType.Ranking.Heavy}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
            <label for="cbxBudgetSystem">{{$lang.CarInspection.Register.BudgetSystem}}:</label>
            <div class="input-group">
              <v-select style="width: 100%"
                      multiple
                      v-model="form.budgetSystem.value"
                      :options="getAllBudgetSystem"/>
            </div>
          </div>
      </div>
    </Forms>

    <Tables ref="tableGrid"
      :columns="[
        '',
        'Sinistro-Versão',
        'Perito',
        'Analista',
        'Seguradora',
        'Tipo de Vistoria',
        'Sistema Orçamentação',
        'Placa',
        'Cidade',
        'Enviado',
        'Visualizado'
      ]"
      :showFullscreen="true"
      :showDownload="true"
      :messageTipFooter="$lang.Common.ClickToSelect"
      v-on:Load="onSearch"
      v-on:Fullscreen="onFullscreen"
      v-on:SaveFile="onExport"
      >
      <tr v-for="obj in this.objList" v-bind:key="obj.regulationAutoSchedulingID">
        <TableColumn :IsCheckbox="true" v-if="obj.status == true" :status="obj.status" :value="obj.regulationAutoSchedulingID" :checked="obj.checked" v-on:Check="onCheck" />
        <TableColumn :IsCheckbox="true" v-else :status="obj.status" :value="obj.regulationAutoSchedulingID" :disabled="true" title="Oficina não cadastrada"/>
        <TableColumn :IsText="true"     :status="obj.status" :value="`${obj.sinisterCode}-${obj.sinisterVersion}`" />
        <TableColumn :IsText="true"     :status="obj.status" :value="obj.expertName" />
        <TableColumn :IsText="true"     :status="obj.status" :value="obj.analystName" />
        <TableColumn :IsText="true"     :status="obj.status" :value="obj.insuranceName" />
        <TableColumn :IsText="true"     :status="obj.status" :value="obj.schedulingTypeName" />
        <TableColumn :IsText="true"     :status="obj.status" :value="obj.budgetSystemName" />
        <TableColumn :IsText="true"     :status="obj.status" :value="obj.plate" />
        <TableColumn :IsText="true"     :status="obj.status" :value="`${obj.cityName} - ${obj.stateName}`" />
        <TableColumn :IsYesNo="true"    :status="obj.status" :valueBool="obj.sentEmail" />
        <TableColumn :IsNumber="true"   :status="obj.status" :value="obj.viewingAmount ? obj.viewingAmount.toString() : '0'" />
      </tr>
      <template v-slot:footer>
        <div class="col-12 text-center">
          <button type="button" class="btn btn-third btn-sm" v-b-tooltip.hover :title="'Enviar email de vistoria para os peritos'" @click="onSendEmail">&nbsp;&nbsp;&nbsp;<i class="fa fa-envelope"></i>&nbsp;&nbsp; Enviar vistorias &nbsp;&nbsp;&nbsp;</button>
        </div>
      </template>
    </Tables>
  </div>
</template>
<script>
import ExpertRoutesSearch from './expertroutessearch.js'
export default ExpertRoutesSearch
</script>



// WEBPACK FOOTER //
// src/views/private/expertroutes/search/expertroutessearch.vue